import { Controller } from '@hotwired/stimulus'
import { enter, leave } from 'el-transition'

export default class extends Controller {
  static targets = [
    'auditTypeInput',
    'frequencyInput',
    'nthDayInput',
    'nthWeekInput',
    'periodInput',
    'scheduleDatesFrame',
    'scheduleInputsFrame',
    'startOnInput',
    'timeframeInput',
  ]

  static values = {
    scheduleDatesUrl: String,
    scheduleInputsUrl: String,
  }

  connect() {
    this.handleAuditTypeChange()
  }

  handleAuditTypeChange() {
    if (this.auditTypeInputTarget.value === 'new_leases') {
      enter(this.periodInputTarget)
    } else {
      leave(this.periodInputTarget)
    }
  }

  handleScheduleChange() {
    const params = new URLSearchParams()
    params.set('frequency', this.frequencyInputTarget.value)
    params.set('nth_day', this.nthDayInputTarget.value)
    if (this.hasNthWeekInputTarget) {
      params.set('nth_week', this.nthWeekInputTarget.value)
    }
    params.set('start_on', this.startOnInputTarget.value)
    params.set('timeframe', this.timeframeInputTarget.value)

    const src = `${this.scheduleDatesUrlValue}?${params.toString()}`

    this.scheduleDatesFrameTarget.src = src
  }

  nthDayInputTargetConnected() {
    this.handleScheduleChange()
  }

  reloadScheduleInputs() {
    const params = new URLSearchParams()
    params.set('lfa_schedule[timeframe]', this.timeframeInputTarget.value)
    params.set('lfa_schedule[frequency]', this.frequencyInputTarget.value)
    this.scheduleInputsFrameTarget.src =
      `${this.scheduleInputsUrlValue}?${params.toString()}`
  }
}
